import React, { useState, useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import Selector from "../components/Selector";
import "./SongsContainer.css";
import SongCard from "../components/SongCard";
import Chord from "../assets/Gmaj.png";

function SongsContainer() {
  const { data, checked } = useContext(MenuContext);
  console.log("checked in songcontainer is:", checked);

  return (
    <div className="SongsContainer">
      <div className="song--results">
        Results:{" "}
        {data.length !== 0
          ? `${data.length} ${data.length > 1 ? "songs" : "song"}`
          : "No songs"}
      </div>

      {/* Cards MAPPING - generating */}
      {data &&
        data.length > 0 &&
        data.map((item) => {
          const checkerx = checked.some((e) => e.id === item.id)
            ? "done"
            : "notdone";
          return (
            <SongCard
              key={item.id}
              checker={checkerx}
              dataItem={item}
              ChordIcon={Chord}
            />
          );
        })}
      {/* End of cards MAPPING  block */}

      {Object.values(checked).length > 0 && <Selector />}
      {/* <Selector /> */}
    </div>
  );
}

export default SongsContainer;
